 
export default [
{
  description: 'Relatório Antropométrico da Turma',
  path: '/relatorios/alimentacao/imc-turma/configuracao',
  name: 'relatorio-imc-turma-configuracao',
  component: () => import('@/views/merenda/medicaoIMC/configuracao.vue'),
},
]
